/**
 * Avaliações ilustrativas do estado vazio do módulo: mostram como a visão
 * geral fica depois da primeira avaliação (etiquetas na silhueta, cartão de
 * peso e variação em relação à anterior). Nunca são gravadas nem misturadas
 * com dados do paciente; somem ao registrar a primeira avaliação real.
 */

export const EXAMPLE_CURRENT = Object.freeze({
  id: 'example-current',
  measuredAt: '2026-02-10 09:00:00',
  measurements: Object.freeze({
    weight: 70.0,
    chest: 94.0,
    waist: 80.0,
    abdomen: 86.5,
    hip: 96.0,
    arm_right: 30.0,
    thigh_right: 55.0,
  }),
});

export const EXAMPLE_REFERENCE = Object.freeze({
  id: 'example-reference',
  measuredAt: '2026-01-10 09:00:00',
  measurements: Object.freeze({
    weight: 71.2,
    chest: 94.0,
    waist: 81.5,
    abdomen: 88.0,
    hip: 96.5,
    arm_right: 29.5,
    thigh_right: 55.5,
  }),
});

export const EXAMPLE_HISTORY = Object.freeze([EXAMPLE_REFERENCE, EXAMPLE_CURRENT]);
